import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useCrimesChartsDataContext } from './hooks/useCrimesChartsDataContext';
import { useSanitizeData } from '../../../Seguranca/Common/hooks/useSanitizeData';

export const DeterminedNatureAnualList = () => {
    const { chartData } = useCrimesChartsDataContext();

    const tableColumns = [
            {
                key: 'ano_competencia',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'natureza_apurada',
                header: 'Natureza Apurada',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.determinedNatureEvolutionAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.naturezas_apuradas.map((natureza) => ({
            ...natureza,
            ano_competencia: itemAno.ano_competencia
        }));
    });

    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Naturezas Apuradas Anuais"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="600px"
            />
        </div>
    );
};